import React, { useEffect, useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { coursesApi } from '@/api/courses/coursesApi';
import { Spinner } from 'reactstrap';
import { studentsApi } from '@/api/students/studentsApi';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import { isoDateStringToYYYYMMDD } from '@/utils/functions';
import LessonModal from '../components/LessonModal';
import { useTranslation } from 'react-i18next';
import TeacherModal from '../../Admin/components/TeacherModal';

const EditComponent = ({ ...props }) => {
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.profile);
    const authData = useSelector((state) => state.auth);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = searchParams.get('id');
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const [detail, setDetail] = useState({});
    const [studentDetail, setStudentDetail] = useState();
    const [toggleModaLesson, setToggleModalLesson] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const handleToggleModalLesson = () => setToggleModalLesson(!toggleModaLesson);
    // const [toggleModalTeacher, setToggleModalTeacher] = useState(false);
    // const [selectedTeacher, setSelectedTeacher] = useState(undefined);
    // const handleToggleModalTeacher = () => setToggleModalTeacher(!toggleModalTeacher);

    const getStudentDetail = () => {
        if (user?.id) {
            studentsApi
                .getDetail(user?.id)
                .then((res) => {
                    const data = res.data.data;
                    setStudentDetail(data);
                })
                .catch((err) => console.error(err));
        }
    };

    const getCourseDetail = () => {
        setIsLoadingDetail(true);
        coursesApi
            .getDetail(id)
            .then((res) => {
                setIsLoadingDetail(false);
                setDetail(res.data.data);
            })
            .catch((err) => console.error(err));
    };

    const handleCourseEnroll = (e) => {
        e.preventDefault();
        setIsLoadingDetail(true);
        if (id) {
            studentsApi
                .courseEnroll(user?.id, {
                    courseId: id
                })
                .then((res) => {
                    setIsLoadingDetail(false);
                    setDetail(res.data);
                    notification.success({ message: t('Course_Student_Edit_EnrollSuccess') });
                })
                .finally(() => {
                    if (id) {
                        getCourseDetail();
                        getStudentDetail();
                    }
                })
                .catch((err) => console.error(err));
        }
    };

    const isStudentEnrolled = studentDetail?.enrollments.some(
        (item) => item?.course?.id === detail?.id
    );

    const userEnoughCredit = (courseData, userData) => {
        const requiredTokenId = courseData?.tokenTypeId;
        const requiredCost = courseData?.tokenCost;
        const userToken = userData?.tokens.find((token) => token?.tokenTypeId === requiredTokenId);
        return !!(userToken && userToken?.credit >= requiredCost);
    };

    const isCourseStart = (startDate) => {                
        return new Date(startDate).getTime() < new Date().getTime();
    };

    useEffect(() => {
        if (id) {
            getCourseDetail();
            getStudentDetail();
        }
    }, [id]);

    // useEffect(() => {
    //     if (!detail?.teacher && isStudentEnrolled) {
    //         handleToggleModalTeacher();
    //     }
    // }, [studentDetail, isStudentEnrolled]);

    // useEffect(() => {
    //     if (!toggleModalTeacher && selectedTeacher && isStudentEnrolled) {
    //         coursesApi.update({ id: id, teacherId: selectedTeacher?.id }).then(() => {
    //             setSelectedTeacher(undefined);
    //             getCourseDetail();
    //         });
    //     }
    // }, [toggleModalTeacher]);

    return (
        <>
            {isLoadingDetail ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        minHeight: '100px'
                    }}>
                    <Spinner
                        size={'sm'}
                        children=""
                    />
                </div>
            ) : (
                <>
                    <div className="section-body">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between align-items-center ">
                                <div className="header-action">
                                    <h1 className="page-title">{t('Course_Student_Edit_Title')}</h1>
                                    <ol className="breadcrumb page-breadcrumb">
                                        <li className="breadcrumb-item">
                                            <span>{t('Course_Student_Edit_BrandName')}</span>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/courses">
                                                {t('Course_Student_Edit_Courses')}
                                            </Link>
                                        </li>
                                        <li
                                            className="breadcrumb-item active"
                                            aria-current="page">
                                            {t('Course_Student_Edit_Details')}
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section-body mt-4">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-4 col-lg-5 col-md-12">
                                    <div className="card">
                                        <a href>
                                            <img
                                                className="card-img-top"
                                                src={
                                                    detail?.thumbnail
                                                        ? detail?.thumbnail
                                                        : '../assets/images/gallery/2.jpg'
                                                }
                                                alt={t('Course_Student_Edit_ImageAlt')}
                                            />
                                        </a>
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="font-bold text-xl">{detail?.title}</h5>
                                            <div className="text-muted">
                                                {detail?.program?.name}
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table table-striped table-vcenter mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="w20">
                                                            <i className="fa fa-calendar text-blue"></i>
                                                        </td>
                                                        <td className="tx-medium">
                                                            {t('Course_Student_Edit_Date')}
                                                        </td>
                                                        <td className="text-right">
                                                            {isoDateStringToYYYYMMDD(
                                                                detail?.startDate
                                                            )}{' '}
                                                            |{' '}
                                                            {isoDateStringToYYYYMMDD(
                                                                detail?.endDate
                                                            )}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w20">
                                                            <i className="fa fa-clock text-blue"></i>
                                                        </td>
                                                        <td className="tx-medium">
                                                            {t('Course_Student_Edit_Duration')}
                                                        </td>
                                                        <td className="text-right">
                                                            {detail?.lessonCount}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <i className="fa fa-shopping-cart text-danger"></i>
                                                        </td>
                                                        <td className="tx-medium">
                                                            {t(detail?.tokenType?.name)}
                                                        </td>
                                                        <td className="text-right">
                                                            {detail?.tokenCost}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <i className="fa fa-users text-warning"></i>
                                                        </td>
                                                        <td className="tx-medium">
                                                            {t('Course_Student_Edit_Students')}
                                                        </td>
                                                        <td className="text-right">
                                                            {detail?.totalEnrollments}/
                                                            {detail?.totalSlot}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* <div className="card-footer">
                                            <div className="d-flex align-items-center mt-auto">
                                                <img
                                                    className="avatar avatar-md mr-3"
                                                    src="../assets/images/xs/avatar4.jpg"
                                                    alt={t('Course_Student_Edit_TeacherAvatarAlt')}
                                                />
                                                <div>
                                                    {detail?.teacher?.firstName}{' '}
                                                    {detail?.teacher?.lastName}
                                                </div>
                                                <div className="ml-auto text-muted">
                                                    {detail?.teacher?.major}{' '}
                                                    {detail?.teacher?.subject}
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>

                                    {authData?.roles[0]?.name == 'Student' && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 10,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%'
                                            }}>
                                            <button
                                                type="submit"
                                                disabled={
                                                    isLoadingDetail ||
                                                    isStudentEnrolled ||
                                                    !userEnoughCredit(detail, studentDetail) ||
                                                    isCourseStart(detail?.startDate)
                                                }
                                                className="mr-1 btn btn-primary"
                                                onClick={(e) => handleCourseEnroll(e)}>
                                                {t('Course_Student_Edit_EnrollButton')}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="col-xl-8 col-lg-7 col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <p>{detail?.description}</p>
                                            <h5 className="mt-4">
                                                {t('Course_Student_Edit_Syllabus')}
                                            </h5>
                                            <ul className="list-group mt-3">
                                                {detail?.scheduleLessons?.map((ele, idx) => (
                                                    <li
                                                        key={idx}
                                                        className="list-group-item d-flex justify-content-between align-items-center cursor-pointer"
                                                        onClick={() => {
                                                            handleToggleModalLesson();
                                                            setSelectedLesson(ele);
                                                        }}>
                                                        {ele?.description}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {toggleModaLesson && (
                <LessonModal
                    selectedLesson={selectedLesson}
                    open={toggleModaLesson}
                    handleToggleModal={handleToggleModalLesson}
                    isStudentEnrolled={isStudentEnrolled}
                />
            )}

            {/* {toggleModalTeacher && (
                <TeacherModal
                    open={toggleModalTeacher}
                    handleToggleModal={handleToggleModalTeacher}
                    handleSelectTeacher={setSelectedTeacher}
                    selectedTeacher={selectedTeacher}
                />
            )} */}
        </>
    );
};

EditComponent.displayName = 'Edit';

const Edit = (props) => (
    <ErrorWrapper>
        <EditComponent
            data-id="Edit-cpn"
            {...props}
        />
    </ErrorWrapper>
);

export default Edit;
